/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：424
 */

module.exports = function (e) {
  if (undefined == e) {
    throw TypeError("Can't call method on " + e)
  }
  return e
}
